export default {"id":"d4c71498","attrs":{"viewBox":"0 0 24 24","width":"24","height":"24"}}